import {
  CreateMenuDto,
  DisplayFoodItem,
  MenuDto,
} from "./food.service.api.dto";
import {
  CreateMenuParam,
  MenuProfile,
  MenuShallowProfile,
  MenuStatuses,
  RestaurantProfile,
  FoodItemDTO,
  FoodItem,
  PriceBy,
  FoodItemTemperature,
  Category,
} from "./food.service.base";

export function translateToRestaurantProfile(dto: any): RestaurantProfile {
  return {
    name: dto.name,
    address: {
      city: dto.addresses?.[0]?.city ?? "",
      state: dto.addresses?.[0]?.state ?? "",
      country: dto.addresses?.[0]?.country ?? "",
      lat: dto.addresses?.[0]?.latitude
        ? parseFloat(dto.addresses[0].latitude)
        : 0,
      long: dto.addresses?.[0]?.longitude
        ? parseFloat(dto.addresses[0].longitude)
        : 0,
      address: dto.addresses?.[0]?.street1 ?? "",
    },
    phoneNumber: dto.contactNumber ?? "",
    email: "",
    website: dto.websiteUrl ?? undefined,
    logoUrl: dto.logo ?? undefined,
    menuIds: [],
    cuisines: dto.merchantCategories || [],
    timezone: dto.timezone,
  };
}

export function convertToMenuDto(createDto: CreateMenuParam): CreateMenuDto {
  const menuDto: CreateMenuDto = {
    name: createDto.name,
    status: createDto.status,
    hours: createDto.hours,
  };

  return menuDto;
}

function formatHourStr(hour: number): string {
  const hours = Math.floor(hour).toString().padStart(2, "0");
  const minutes = ((hour % 1) * 60).toFixed(0).padStart(2, "0");
  return `${hours}:${minutes}`;
}

export function mapMenuDtoToMenuProfile(menuDto: MenuDto): MenuProfile {
  const { id, name, status, hours, categories } = menuDto;

  // const servingHour: ServingHour = convertHoursToServingHour(hours);

  const categoryIds: string[] = [];

  return {
    id: id,
    name: name,
    status: status as MenuStatuses,
    hours,
    categoryId: categoryIds,
    categories: categories,
  };
}

export function mapMenuDtoToMenuShallowProfile(
  menuDto: MenuDto,
): MenuShallowProfile {
  // Extract id and name from MenuDto
  const id = menuDto.id;
  const name = menuDto.name;

  // Extract status and map to MenuStatuses
  const status = menuDto.status as MenuStatuses; // Assuming MenuStatuses is a subset of possible values in menuDto.status

  return {
    id,
    name,
    hours: menuDto.hours,
    status,
  };
}

export function mapItemResponseToMenuItemList(
  items: FoodItemDTO[],
): DisplayFoodItem[] {
  return items.map((item) => {
    const transformedItem: DisplayFoodItem = {
      ...item,
      categories: item.categories.map((category) => category.name),
      menus: item.menus.map((menu) => menu.name),
    };
    return transformedItem;
  });
}
export function mapItemDtoToFoodItem(itemDto: any): FoodItem {
  return {
    id: itemDto.id,
    name: itemDto.name,
    profileImageUrl: itemDto.profileImage,
    categoryId: [], //TODO: fix for multiple cat
    price: parseFloat(itemDto.price),
    categories: itemDto.categories,
    priceBy: PriceBy.EACH,
    vat: parseFloat(itemDto.vat),
    temperature: mapTemperature(itemDto.temperature),
    dietaryAttributes: itemDto.dietaryAttributes || [],
    outOfStock: itemDto.outOfStock,
  };
}

// Direct mapping function for Temperature
function mapTemperature(temperature: string): FoodItemTemperature {
  return temperature as FoodItemTemperature;
}

export function mapCategoryDtoToCategory(categoryDto: any): Category {
  return {
    id: categoryDto.id,
    name: categoryDto.name,
    menuIds: [], // temporarily,
    items: categoryDto.items.map(mapItemDtoToFoodItem),
  };
}
